const rankings = [
  {
    rank: 1,
    title: '秘密教学',
    tag: '韩漫',
    tagColor: 'bg-accent-100 text-accent-700',
    heat: '本周热度 128万',
    change: 'up',
    desc: '豪门继承人与女教师的禁忌之恋，全网热议韩漫天花板',
  },
  {
    rank: 2,
    title: '咒术回战',
    tag: '日漫',
    tagColor: 'bg-primary-100 text-primary-700',
    heat: '本周热度 98万',
    change: 'up',
    desc: '咒术师与诅咒的生死对抗，最终章剧情引爆讨论',
  },
  {
    rank: 3,
    title: '斗破苍穹',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
    heat: '本周热度 85万',
    change: 'same',
    desc: '萧炎中州篇全彩连载，国漫经典持续霸榜前三',
  },
  {
    rank: 4,
    title: '女神降临',
    tag: '韩漫',
    tagColor: 'bg-accent-100 text-accent-700',
    heat: '本周热度 72万',
    change: 'down',
    desc: '完结效应持续发酵，番外篇热度不减仍居第四',
  },
  {
    rank: 5,
    title: '一人之下',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
    heat: '本周热度 65万',
    change: 'up',
    desc: '唐门篇高潮迭起，国漫人气稳步上升进入前五',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10 md:mb-12">
          <div>
            <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-2">
              排行榜
            </h2>
            <p className="text-sm text-foreground-500">本周热门漫画热度排行TOP5</p>
          </div>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
            <button className="px-4 py-1.5 rounded-full text-sm font-medium bg-background-50 text-foreground-900 whitespace-nowrap cursor-pointer">热度榜</button>
            <button className="px-4 py-1.5 rounded-full text-sm text-foreground-500 hover:text-foreground-700 whitespace-nowrap cursor-pointer">新作榜</button>
            <button className="px-4 py-1.5 rounded-full text-sm text-foreground-500 hover:text-foreground-700 whitespace-nowrap cursor-pointer">讨论榜</button>
          </div>
        </div>

        <div className="space-y-3">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-4 md:p-5 flex items-center gap-4 md:gap-5 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-background-50 flex items-center justify-center">
                <span className={`font-heading text-lg ${i < 3 ? 'text-accent-500' : 'text-foreground-400'}`}>
                  {String(item.rank).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base text-foreground-900">{item.title}</h3>
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${item.tagColor}`}>
                    {item.tag}
                  </span>
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-line text-green-500 text-xs"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-line text-red-400 text-xs"></i>
                  )}
                  {item.change === 'same' && (
                    <i className="ri-subtract-line text-foreground-400 text-xs"></i>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-sm font-semibold text-foreground-900">{item.heat}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}